import { configureStore } from '@reduxjs/toolkit';
import counterReducer from './features/counterSlice'; // Import your slice reducer
import resultReducer from './features/resultSlice';
import  questionReducer  from './features/qustionSlice';

const store = configureStore({
  reducer: {
    counter: counterReducer, // Add slice reducers here
    result: resultReducer,
    questionResult: questionReducer,
  },
});

export default store;
